/**
 * Auto-generated collected component map.
 * Regenerated by `npm run generate:registry` -- do not edit manually.
 *
 * @generated
 */
import type { ComponentType } from "react";

export interface CollectedEntry {
  component: () => Promise<{ default: ComponentType }>;
}

export const COLLECTED_COMPONENTS: Record<string, CollectedEntry> = {
  "clip-path-reveal": {
    component: () => import("./clip-path-reveal/ClipPathReveal"),
  },
  "counter-flip-reveal": {
    component: () => import("./counter-flip-reveal/CounterFlipReveal"),
  },
  "curved-text-scroll": {
    component: () => import("./curved-text-scroll/CurvedTextScroll"),
  },
  "custom-video-player": {
    component: () => import("./custom-video-player/CustomVideoPlayer"),
  },
  "feature-convergence": {
    component: () => import("./feature-convergence/FeatureConvergence"),
  },
  "fibonacci-image-orb": {
    component: () => import("./fibonacci-image-orb/FibonacciImageOrb"),
  },
  "image-explosion": {
    component: () => import("./image-explosion/ImageExplosion"),
  },
  "physics-tag-cloud": {
    component: () => import("./physics-tag-cloud/PhysicsTagCloud"),
  },
  "scroll-frame-canvas": {
    component: () => import("./scroll-frame-canvas/ScrollFrameCanvas"),
  },
  "split-card-flip": {
    component: () => import("./split-card-flip/SplitCardFlip"),
  },
  "spotlight-image-stack": {
    component: () => import("./spotlight-image-stack/SpotlightImageStack"),
  },
  "sticky-cards-fold": {
    component: () => import("./sticky-cards-fold/StickyCardsFold"),
  },
  "sticky-cards-scale": {
    component: () => import("./sticky-cards-scale/StickyCardsScale"),
  },
  "sticky-cards-tilt": {
    component: () => import("./sticky-cards-tilt/StickyCardsTilt"),
  },
};

export const COLLECTED_SLUGS = Object.keys(COLLECTED_COMPONENTS);
